import {FC, useEffect, useState, BaseSyntheticEvent} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Button} from '../../../components/Button/Button'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import {Input} from '../../../components/Input/Input'
import Swal from 'sweetalert2'
import uuid from 'react-uuid'
import styles from './config.module.css'
import useModals from '../../../hooks/useModals'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {EditorQuill} from '../../../components/EditorQuill/EditorQuill'

type BookingDayType = {
  day: 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday'
  able: boolean
  bookingHours: string[]
}

type BookingHourType = {
  hour: string
}

type BookingDayResponseType = {
  day: 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday'
  able: boolean
  hours: BookingHourType[]
}

type DayType = {
  name: 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday'
  nick: 'sun' | 'mon' | 'tue' | 'wed' | 'thur' | 'fri' | 'sat'
  able: boolean
}

const BookingConfigContent: FC = () => {
  const {showWrapperModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [link, setLink] = useState('')
  const [able, setAble] = useState(false)
  const [maxPeople, setMaxPeople] = useState(0)
  const [expiryTime, setExpiryTime] = useState(0)
  const [dayConfirm, setDayConfirm] = useState(false)
  const [paymentConfirm, setPaymentConfirm] = useState(false)
  const [valuePaymentConfirm, setValuePaymentConfirm] = useState(0)
  const [useDurationBooking, setUseDurationBooking] = useState(false)
  const [durationBooking, setDurationBooking] = useState('00:00')
  const [useCancelBooking, setUseCancelBooking] = useState(false)
  const [durationCancelBooking, setDurationCancelBooking] = useState('00:00')
  const [useTerms, setUseTerms] = useState(false)
  const [enableTableManagement, setEnableTableManagement] = useState(false)
  const [allowCustomerConfirmation, setAllowCustomerConfirmation] = useState(false)
  const [image1, setImage1] = useState<File | null | string>(null)
  const [firstStateImage1, setFirstStateImage1] = useState<File | null | string>(null)
  const [image2, setImage2] = useState<File | null | string>(null)
  const [firstStateImage2, setFirstStateImage2] = useState<File | null | string>(null)
  const [selectedImages, setSelectedImages] = useState<Array<string>>([])
  const [observation, setObservation] = useState('')
  const [dragOverImage1, setDragOverImage1] = useState(false)
  const [dragOverImage2, setDragOverImage2] = useState(false)

  const [daySelected, setDaySelected] = useState<BookingDayType | null>(null)
  const [bookingDays, setBookingsDays] = useState<BookingDayType[]>([])
  const [bookingDaysFirstState, setBookingsDaysFirstState] = useState<BookingDayType[]>([])
  const [days, setDays] = useState<DayType[]>([
    {
      name: 'sunday',
      nick: 'sun',
      able: false,
    },
    {
      name: 'monday',
      nick: 'mon',
      able: false,
    },
    {
      name: 'tuesday',
      nick: 'tue',
      able: false,
    },
    {
      name: 'wednesday',
      nick: 'wed',
      able: false,
    },
    {
      name: 'thursday',
      nick: 'thur',
      able: false,
    },
    {
      name: 'friday',
      nick: 'fri',
      able: false,
    },
    {
      name: 'saturday',
      nick: 'sat',
      able: false,
    },
  ])

  const changeBookingConfig = async (saveDayHour?: boolean) => {
    try {
      setLoading(true)
      const bookingDaysSend = bookingDays.map((bk) => ({
        day: bk.day,
        able: bk.able,
        bookingHours: bk.bookingHours.map((hour) => ({hour})),
      }))
      const res = await POST('/queueReservation/bookingConfig', {
        able,
        maxPeople,
        expiryTime,
        dayConfirm,
        paymentConfirm,
        valuePaymentConfirm: Math.trunc(valuePaymentConfirm * 100),
        bookingDays: bookingDays === bookingDaysFirstState && !saveDayHour ? [] : bookingDaysSend,
        useTerms,
        enableTableManagement,
        allowCustomerConfirmation,
        duration: useDurationBooking
          ? parseInt(durationBooking.split(':')[0]) * 60 + parseInt(durationBooking.split(':')[1])
          : 0,
        observation,
        cancel: useCancelBooking
          ? parseInt(durationCancelBooking.split(':')[0]) * 60 +
            parseInt(durationCancelBooking.split(':')[1])
          : 0,
      })
      if (res && res.data && res.data) {
        const bookingConfig = res.data
        let imagesBooking = []

        if (image1 && image1 !== firstStateImage1) {
          if (
            firstStateImage1 &&
            !firstStateImage1.toString().includes('img.ninegrid.com/exemplo/')
          ) {
            await POST('/upload-images/delete-one', {
              url: firstStateImage1,
            })
          }
          const formData = new FormData()
          formData.append('file', image1)
          formData.append('nameImage', `booking-config-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes && imageRes.image) {
            imagesBooking.push(imageRes.image)
          }
        } else if (image1 && image1 === firstStateImage1) {
          imagesBooking.push(image1)
        }

        if (image2 && image2 !== firstStateImage2) {
          if (
            firstStateImage2 &&
            !firstStateImage2.toString().includes('img.ninegrid.com/exemplo/')
          ) {
            await POST('/upload-images/delete-one', {
              url: firstStateImage2,
            })
          }
          const formData = new FormData()
          formData.append('file', image2)
          formData.append('nameImage', `booking-config-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes && imageRes.image) {
            imagesBooking.push(imageRes.image)
          }
        } else if (image2 && image2 === firstStateImage2) {
          imagesBooking.push(image2)
        }

        if (selectedImages[0] && imagesBooking.length < 2) {
          imagesBooking.push(selectedImages[0])
        }
        if (selectedImages[1] && imagesBooking.length < 2) {
          imagesBooking.push(selectedImages[1])
        }

        await POST('/queueReservation/bookingImage', {
          images: imagesBooking,
          bookingConfigId: bookingConfig.id,
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Configuração realizada!',
        }).then(async () => await init())
      } else {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao configurar reserva!',
        })
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao configurar reserva!',
      })
    }
  }

  const getBookingConfig = async () => {
    try {
      const res = await GET('/queueReservation/bookingConfig')
      if (res && res.success && res.data && res.data.length > 0) {
        const bookingConfig = res.data[0]
        setAble(bookingConfig.able)
        setMaxPeople(bookingConfig.maxPeople)
        setExpiryTime(bookingConfig.expiryTime)
        setPaymentConfirm(bookingConfig.paymentConfirm)
        setValuePaymentConfirm(bookingConfig.valuePaymentConfirm / 100)
        setDayConfirm(bookingConfig.dayConfirm)
        setUseTerms(bookingConfig.useTerms)
        setEnableTableManagement(bookingConfig.enableTableManagement === 1)
        setAllowCustomerConfirmation(bookingConfig.allowCustomerConfirmation === 1)
        setUseDurationBooking(bookingConfig.duration > 0 ? true : false)
        setUseCancelBooking(bookingConfig.cancel > 0 ? true : false)
        setObservation(bookingConfig.observation)
        if (bookingConfig.duration > 0) {
          const hour = Math.trunc(bookingConfig.duration / 60)
          const minute = bookingConfig.duration - hour * 60
          setDurationBooking(
            `${hour > 9 ? hour : `0${hour}`}:${minute > 9 ? minute : `0${minute}`}`
          )
        }
        if (bookingConfig.cancel > 0) {
          const hour = Math.trunc(bookingConfig.cancel / 60)
          const minute = bookingConfig.cancel - hour * 60
          setDurationCancelBooking(
            `${hour > 9 ? hour : `0${hour}`}:${minute > 9 ? minute : `0${minute}`}`
          )
        }
        const bookingDaysGet = bookingConfig.days.map((dayBk: BookingDayResponseType) => ({
          able: dayBk.able,
          day: dayBk.day,
          bookingHours: dayBk.hours.map((hourBk) => hourBk.hour),
        }))
        const newDays = days.map((dayItem) => {
          const bookingFind = bookingConfig.days.find(
            (dayBooking: BookingDayResponseType) => dayBooking.day === dayItem.name
          )
          if (bookingFind) dayItem.able = bookingFind.able
          return dayItem
        })
        setDays(newDays)
        setBookingsDays(bookingDaysGet)
        setBookingsDaysFirstState(bookingDaysGet)
        setImage1(null)
        setImage2(null)
        setFirstStateImage1(null)
        setFirstStateImage2(null)
        if (bookingConfig.images) {
          let urls = []
          const images = bookingConfig.images.sort((a: any, b: any) =>
            parseInt(a.id) > parseInt(b.id) ? 1 : parseInt(b.id) > parseInt(a.id) ? -1 : 0
          )
          if (images[0]) {
            if (images[0].url.includes('img.ninegrid.com/exemplo/')) {
              urls.push(images[0].url)
            } else {
              setImage1(images[0].url)
              setFirstStateImage1(images[0].url)
            }
          } else {
            setImage1(null)
            setFirstStateImage1(null)
          }
          if (images[1]) {
            if (images[1].url.includes('img.ninegrid.com/exemplo/')) {
              urls.push(images[1].url)
            } else {
              setImage2(images[1].url)
              setFirstStateImage2(images[1].url)
            }
          } else {
            setImage2(null)
            setFirstStateImage2(null)
          }
          setSelectedImages(urls)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getLink = async () => {
    const appRes = await GET('/appconfig')
    if (appRes && appRes.data) {
      const webapp = appRes.data.find((app: any) => app.type === 'qr')
      let url = ''
      if (webapp) {
        if (process.env.REACT_APP_PROD === '1') {
          url =
            'https://webapp' +
            '.ninegrid.com.br/' +
            window.btoa(webapp.pluginSpace.subdomain) +
            '/booking'
        } else {
          url =
            process.env.REACT_APP_WEBAPP_URL +
            '/' +
            window.btoa(webapp.pluginSpace.subdomain) +
            '/booking'
        }
      }
      setLink(url)
    }
  }

  const init = async () => {
    setLoading(true)
    await getLink()
    await getBookingConfig()
    setLoading(false)
  }

  const selectImage = (url: string) => {
    if (selectedImages.includes(url)) {
      setSelectedImages(selectedImages.filter((i) => i !== url))
    } else {
      if (selectedImages.length < 2) {
        const newSelecteds = selectedImages.map((i) => i)
        newSelecteds.push(url)
        setSelectedImages(newSelecteds)
      }
    }
  }

  const handleDragStart = (e: any, imageUrl: string) => {
    e.dataTransfer.effectAllowed = 'copy'
    e.dataTransfer.setData('imageUrl', imageUrl)
  }

  const handleDragOver = (e: any) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'copy'
  }

  const handleDropImage1 = (e: any) => {
    e.preventDefault()
    setDragOverImage1(false)
    const imageUrl = e.dataTransfer.getData('imageUrl')
    if (imageUrl) setImage1(imageUrl)
  }

  const handleDropImage2 = (e: any) => {
    e.preventDefault()
    setDragOverImage2(false)
    const imageUrl = e.dataTransfer.getData('imageUrl')
    if (imageUrl) setImage2(imageUrl)
  }

  const changeDayBookingConfig = async () => {
    const newDays = bookingDays.map((b) => b)
    newDays.forEach((bk) => {
      if (daySelected && bk.day === daySelected.day) {
        bk = daySelected
      }
    })
    const newDaysItems = days.map((dayItem) => {
      const bookingFind = newDays.find((dayBooking) => dayBooking.day === dayItem.name)
      if (bookingFind) dayItem.able = bookingFind.able
      return dayItem
    })
    setDays(newDaysItems)
    setBookingsDays(newDays)
    await changeBookingConfig(true)
  }

  const changeHour = (hour: string) => {
    if (daySelected) {
      setLoading(true)
      const day: BookingDayType = Object.assign(daySelected)
      if (day.bookingHours.includes(hour)) {
        const hours = day.bookingHours.filter((h) => h !== hour)
        day.bookingHours = hours
        setDaySelected(day)
      } else {
        day.bookingHours.push(hour)
        setDaySelected(day)
      }
      setTimeout(() => {
        setLoading(false)
      }, 200)
    }
  }

  const validate = (value: string) => {
    if (value) {
      value = value.replaceAll('_', '0')
      const values = value.split(':')
      let val1 = parseInt(values[0]) > 23 ? 23 : values[0]
      let val2 = parseInt(values[0]) > 23 || parseInt(values[1]) > 59 ? 59 : values[1]
      value = `${val1}:${val2}`
    }
    return value
  }

  // Validação para durações (não limitar horas em 24h — apenas garantir minutos <= 59)
  const validateDuration = (value: string) => {
    if (value) {
      value = value.replaceAll('_', '0')
      const values = value.split(':')
      const val1 = values[0] // permitir horas além de 23
      const val2 = parseInt(values[1]) > 59 ? '59' : values[1]
      value = `${val1}:${val2}`
    }
    return value
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`booking.config`)}</span>
                  <BreadCrumbs />
                </h3>
              </div>
              <div className='card-body'>
                {/* Seção de Status e Link na mesma linha */}
                <div className='row mb-5 align-items-center'>
                  <div className='col-md-3'>
                    <div className='d-flex align-items-center gap-3'>
                      <span className='fw-bolder fs-6'>{i18n.t(`booking.able`)}</span>
                      <div>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={able}
                          value={able}
                          change={(value: boolean) => setAble(value)}
                          marginTop='0'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-9'>
                    <div className='d-flex align-items-center gap-2'>
                      <span className='fw-bolder fs-6 text-nowrap'>{i18n.t(`booking.link`)}</span>
                      <div style={{maxWidth: '64ch'}}>
                        <a
                          href={link}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-primary text-decoration-none'
                          style={{
                            fontSize: '0.95rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            display: 'block',
                            border: 'none',
                            background: 'transparent',
                            padding: '0.25rem 0',
                          }}
                          title={link}
                        >
                          {link}
                        </a>
                      </div>
                      <button
                        className='btn btn-sm btn-icon btn-light-primary'
                        type='button'
                        title='Copiar link'
                        onClick={() => {
                          navigator.clipboard.writeText(link)
                          Swal.fire({
                            icon: 'success',
                            title: 'Link copiado!',
                            text: 'O link foi copiado para a área de transferência.',
                            showConfirmButton: false,
                            timer: 1500,
                          })
                        }}
                      >
                        <i className='bi bi-clipboard'></i>
                      </button>
                      <button
                        className='btn btn-sm btn-icon btn-light-success'
                        type='button'
                        title='Compartilhar link'
                        onClick={() => {
                          if (navigator.share) {
                            navigator
                              .share({
                                title: 'Link de Reserva',
                                text: 'Faça sua reserva através deste link',
                                url: link,
                              })
                              .catch(() => {})
                          } else {
                            window.open(
                              `https://wa.me/?text=${encodeURIComponent(
                                'Faça sua reserva: ' + link
                              )}`,
                              '_blank'
                            )
                          }
                        }}
                      >
                        <i className='bi bi-share'></i>
                      </button>
                    </div>
                  </div>
                </div>
                {/* Dias da Semana */}
                <hr className='border border-1 opacity-75'></hr>
                <div className='mb-6'>
                  <span className='fw-bolder fs-6 d-block mb-3'>{i18n.t(`booking.days_week`)}</span>
                  <div className='d-flex flex-wrap gap-2'>
                    {days.map((dayItem) => (
                      <button
                        key={dayItem.name}
                        className={dayItem.able ? styles.buttonActiveWeekDay : styles.buttonWeekDay}
                        onClick={() => {
                          const day = bookingDays.find((bk) => bk.day === dayItem.name)
                          if (day) {
                            setDaySelected(day)
                          } else {
                            const newDay: BookingDayType = {
                              able: false,
                              bookingHours: [],
                              day: dayItem.name,
                            }
                            setDaySelected(newDay)
                            const days = bookingDays.map((bk) => bk)
                            days.push(newDay)
                            setBookingsDays(days)
                          }
                          showWrapperModal(i18n.t(`week_day_full.${dayItem.nick}`))
                        }}
                      >
                        {i18n.t(`week_day.${dayItem.nick}`)}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Card 1: Configurações Básicas */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-gear-fill text-primary me-2'></i>
                    Configurações Básicas
                  </h5>
                </div>
                <div className='card-body'>
                  <div className='row g-4'>
                    <div className='col-md-6 col-xl-3'>
                      <Input
                        inputAttr={{
                          type: 'number',
                          min: 1,
                        }}
                        label={i18n.t(`booking.max_people`)}
                        value={maxPeople}
                        change={(value: number) => setMaxPeople(value)}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`booking.max_people_text`)}
                      </small>
                    </div>

                    <div className='col-md-6 col-xl-3'>
                      <Input
                        inputAttr={{
                          type: 'number',
                          min: 0,
                        }}
                        label={i18n.t(`booking.expiry_time`)}
                        value={expiryTime}
                        change={(value: number) => setExpiryTime(value)}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`booking.expiry_time_text`)}
                      </small>
                    </div>

                    <div className='col-md-6 col-xl-3'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        value={dayConfirm}
                        change={(value: boolean) => setDayConfirm(value)}
                        label={i18n.t(`booking.day_confirm`)}
                        options={[
                          {select: 'Sim', value: true},
                          {select: 'Não', value: false},
                        ]}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`booking.day_confirm_text`)}
                      </small>
                    </div>

                    <div className='col-md-6 col-xl-3'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`booking.value_payment_confirm`)}
                        change={(value: number) => setValuePaymentConfirm(value)}
                        value={valuePaymentConfirm}
                      />
                    </div>
                  </div>

                  {/* Accordian - Saiba Mais */}
                  <div className='accordion mt-5 border-top pt-4' id='accordionBasic'>
                    <div className='accordion-item border-0 rounded'>
                      <h2 className='accordion-header' id='headingBasic'>
                        <button
                          className='accordion-button collapsed fw-bold text-dark'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseBasic'
                          aria-expanded='false'
                          aria-controls='collapseBasic'
                        >
                          <i className='bi bi-info-circle me-2 text-info'></i>
                          Saiba mais...
                        </button>
                      </h2>
                      <div
                        id='collapseBasic'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingBasic'
                        data-bs-parent='#accordionBasic'
                      >
                        <div className='accordion-body bg-light-info'>
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-people-fill text-primary me-2'></i>
                              Máximo de Pessoas
                            </h6>
                            <p className='text-muted mb-2'>
                              Define o limite total de pessoas que podem ser reservadas em simultâneo no período. Vale para o dia inteiro quando a duração não está configurada.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Se atingir este limite, o sistema recusará novas reservas até alguém cancelar.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-hourglass-split text-warning me-2'></i>
                              Tempo de Expiração
                            </h6>
                            <p className='text-muted mb-2'>
                              Minutos que a reserva fica ativa antes de ser cancelada automaticamente se o cliente não confirmar a presença.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Tempo muito baixo pode frustrar clientes; muito alto pode deixar mesas bloqueadas sem uso.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-calendar-check text-success me-2'></i>
                              Confirmação no Mesmo Dia
                            </h6>
                            <p className='text-muted mb-2'>
                              Obriga o cliente a confirmar a presença no mesmo dia da reserva.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Aumenta a taxa de no-shows; clientes esquecem de confirmar.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 2: Opções de Reserva */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-toggles text-success me-2'></i>
                    Opções de Reserva
                  </h5>
                </div>
                <div className='card-body'>
                  <div className='row g-5'>
                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useDurationBooking}
                          value={useDurationBooking}
                          change={(value: boolean) => setUseDurationBooking(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>{i18n.t(`booking.use_time`)}</label>
                          <p className='text-muted fs-7 mb-0'>Definir duração para cada reserva</p>
                        </div>
                      </div>
                      {useDurationBooking && (
                        <div className='mt-3 ms-5'>
                          <Input
                            inputAttr={{
                              type: 'hour',
                            }}
                            value={durationBooking}
                            change={(value: string) => setDurationBooking(value)}
                            placeholder='00:00'
                            label={`${i18n.t(`booking.time`)}`}
                            blur={(value: string) => setDurationBooking(validate(value))}
                          />
                        </div>
                      )}
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={paymentConfirm}
                          value={paymentConfirm}
                          change={(value: boolean) => setPaymentConfirm(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            {i18n.t(`booking.payment_confirm`)}
                          </label>
                          <p className='text-muted fs-7 mb-0'>Exigir pagamento antecipado</p>
                        </div>
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useTerms}
                          value={useTerms}
                          change={(value: boolean) => setUseTerms(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>{i18n.t(`booking.use_terms`)}</label>
                          <p className='text-muted fs-7 mb-0'>Aceitar termos de uso</p>
                        </div>
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useCancelBooking}
                          value={useCancelBooking}
                          change={(value: boolean) => setUseCancelBooking(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            {i18n.t(`booking.use_cancel`)}
                          </label>
                          <p className='text-muted fs-7 mb-0'>Permitir cancelamento pelo cliente</p>
                        </div>
                      </div>
                      {useCancelBooking && (
                        <div className='mt-3 ms-5'>
                          <Input
                            inputAttr={{
                              type: 'hour',
                            }}
                            value={durationCancelBooking}
                            change={(value: string) => setDurationCancelBooking(value)}
                            placeholder='00:00'
                            label={`${i18n.t(`booking.time_cancel`)}`}
                            blur={(value: string) =>
                              setDurationCancelBooking(validateDuration(value))
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Accordian - Saiba Mais */}
                  <div className='accordion mt-5 border-top pt-4' id='accordionReservation'>
                    <div className='accordion-item border-0 rounded'>
                      <h2 className='accordion-header' id='headingReservation'>
                        <button
                          className='accordion-button collapsed fw-bold text-dark'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseReservation'
                          aria-expanded='false'
                          aria-controls='collapseReservation'
                        >
                          <i className='bi bi-info-circle me-2 text-info'></i>
                          Saiba mais...
                        </button>
                      </h2>
                      <div
                        id='collapseReservation'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingReservation'
                        data-bs-parent='#accordionReservation'
                      >
                        <div className='accordion-body bg-light-success'>
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-clock text-primary me-2'></i>
                              Usar Duração de Reserva
                            </h6>
                            <p className='text-muted mb-2'>
                              Quando ativado, cada reserva ocupa a mesa por um tempo específico. Libera espaço para novos clientes no mesmo dia em horários diferentes.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Aumenta a rotatividade; permite mais reservas no dia. Desativado conta reservas para todo o dia.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-credit-card text-warning me-2'></i>
                              Exigir Pagamento Antecipado
                            </h6>
                            <p className='text-muted mb-2'>
                              Cliente precisa pagar antes de confirmar a reserva.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Reduz no-shows; gera receita imediata. Pode desestimular alguns clientes.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-file-text text-danger me-2'></i>
                              Aceitar Termos de Uso
                            </h6>
                            <p className='text-muted mb-2'>
                              Cliente deve concordar com as políticas ao fazer reserva.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Proteção legal; melhor comunicação de políticas. Aumenta etapas no fluxo.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-x-circle text-danger me-2'></i>
                              Permitir Cancelamento
                            </h6>
                            <p className='text-muted mb-2'>
                              Define pela quantas horas antes da reserva o cliente pode cancelar.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Clientes têm flexibilidade. Se permitido muito perto, mesa pode ficar com cancelamento de última hora.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 3: Funcionalidades Avançadas */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-stars text-warning me-2'></i>
                    Funcionalidades Avançadas
                  </h5>
                </div>
                <div className='card-body'>
                  <div className='row g-5'>
                    <div className='col-md-6'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={enableTableManagement}
                          value={enableTableManagement}
                          change={(value: boolean) => setEnableTableManagement(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-table me-1'></i>
                            Gestão de Mesa
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            Ao confirmar a presença do cliente, o sistema irá sugerir mesas
                            disponíveis para alocação
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={allowCustomerConfirmation}
                          value={allowCustomerConfirmation}
                          change={(value: boolean) => setAllowCustomerConfirmation(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-check-circle me-1'></i>
                            Confirmação do Cliente
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            O cliente poderá confirmar sua própria chegada através do WebApp
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Accordian - Saiba Mais */}
                  <div className='accordion mt-5 border-top pt-4' id='accordionAdvanced'>
                    <div className='accordion-item border-0 rounded'>
                      <h2 className='accordion-header' id='headingAdvanced'>
                        <button
                          className='accordion-button collapsed fw-bold text-dark'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseAdvanced'
                          aria-expanded='false'
                          aria-controls='collapseAdvanced'
                        >
                          <i className='bi bi-info-circle me-2 text-info'></i>
                          Saiba mais...
                        </button>
                      </h2>
                      <div
                        id='collapseAdvanced'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingAdvanced'
                        data-bs-parent='#accordionAdvanced'
                      >
                        <div className='accordion-body bg-light-warning'>
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-table text-primary me-2'></i>
                              Gestão de Mesa
                            </h6>
                            <p className='text-muted mb-2'>
                              Quando o cliente confirma chegada, o sistema automaticamente sugere mesas disponíveis otimizadas por capacidade.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Reduz trabalho manual do atendente; melhora experiência do cliente. Requer ambiente com mesas configuradas.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-check-circle text-success me-2'></i>
                              Confirmação do Cliente
                            </h6>
                            <p className='text-muted mb-2'>
                              Permite que o cliente confirme sua chegada diretamente no WebApp sem precisar do atendente.
                            </p>
                            <p className='text-muted small mb-0'>
                              <strong>Impacto:</strong> Mais eficiente; reduz fila no balcão. Clientes precisam ter acesso ao link/QR code.
                            </p>
                          </div>
                          <hr className='my-3' />
                          <div className='mb-3'>
                            <h6 className='fw-bold text-dark mb-2'>
                              <i className='bi bi-gear text-secondary me-2'></i>
                              Recomendação
                            </h6>
                            <p className='text-muted small mb-0'>
                              <strong>Ativar ambas:</strong> Proporciona um fluxo completo e automatizado. Cliente reserva → Confirma chegada → Sistema sugere mesa.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-chat-left-text text-info me-2'></i>
                    {i18n.t(`queue.observation`)}
                  </h5>
                </div>
                <div className='card-body'>
                  <EditorQuill
                    value={observation}
                    change={(value: string) => setObservation(value)}
                    height={200}
                  />
                  <small className='text-muted d-block mt-2'>
                    Adicione observações importantes que serão exibidas aos clientes
                  </small>
                </div>
              </div>

              {/* COMENTADO: Card 5: Imagens - Definição de imagens */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light d-flex justify-content-between align-items-center'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-image text-danger me-2'></i>
                    {i18n.t(`booking.image_title`)}
                  </h5>
                  <span className='badge badge-light-primary'>
                    {selectedImages.length} / 2 selecionadas
                  </span>
                </div>
                <div className='card-body'>
                  <p className='text-muted mb-4'>{i18n.t(`booking.image_text`)}</p>

                  <div className='border border-2 border-dashed rounded p-4 mb-4 bg-light-primary'>
                    <h6 className='fw-bold text-gray-800 mb-3'>
                      <i className='bi bi-cloud-upload text-primary me-2'></i>
                      Enviar Imagens Personalizadas
                    </h6>
                    <div className='row g-3'>
                      <div className='col-md-6'>
                        <div
                          onDragOver={handleDragOver}
                          onDrop={handleDropImage1}
                          onDragEnter={() => setDragOverImage1(true)}
                          onDragLeave={() => setDragOverImage1(false)}
                          style={{
                            border: dragOverImage1 ? '2px solid #50cd89' : 'none',
                            backgroundColor: dragOverImage1 ? '#e8f5e9' : 'transparent',
                            borderRadius: '4px',
                            padding: dragOverImage1 ? '8px' : '0px',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <Input
                            inputAttr={{
                              type: 'image',
                            }}
                            label={`${i18n.t(`booking.image`)} 1`}
                            value={image1}
                            change={(value: BaseSyntheticEvent) =>
                              setImage1(value ? value.target.files[0] : null)
                            }
                          />
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div
                          onDragOver={handleDragOver}
                          onDrop={handleDropImage2}
                          onDragEnter={() => setDragOverImage2(true)}
                          onDragLeave={() => setDragOverImage2(false)}
                          style={{
                            border: dragOverImage2 ? '2px solid #50cd89' : 'none',
                            backgroundColor: dragOverImage2 ? '#e8f5e9' : 'transparent',
                            borderRadius: '4px',
                            padding: dragOverImage2 ? '8px' : '0px',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <Input
                            inputAttr={{
                              type: 'image',
                            }}
                            label={`${i18n.t(`booking.image`)} 2`}
                            value={image2}
                            change={(value: BaseSyntheticEvent) =>
                              setImage2(value ? value.target.files[0] : null)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className='mt-2'>
                      <small className='text-muted'>
                        <i className='bi bi-info-circle me-1'></i>
                        Você também pode arrastar imagens da galeria abaixo
                      </small>
                    </div>
                  </div>

                  <div className='border border-2 border-dashed rounded p-4 bg-light-success'>
                    <h6 className='fw-bold text-gray-800 mb-3'>
                      <i className='bi bi-images text-success me-2'></i>
                      Galeria de Imagens (selecione até 2)
                    </h6>
                    <div className='row g-3'>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                        <div key={item} className='col-6 col-sm-4 col-md-3 col-xl-2'>
                          <div
                            draggable
                            onDragStart={(e) =>
                              handleDragStart(
                                e,
                                `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                              )
                            }
                            className='position-relative cursor-pointer rounded overflow-hidden shadow-sm hover-shadow-lg transition'
                            style={{
                              border: selectedImages.includes(
                                `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                              )
                                ? '3px solid #50cd89'
                                : '2px solid #e4e6ef',
                              aspectRatio: '4/3',
                              transition: 'all 0.2s ease',
                              cursor: 'grab',
                            }}
                            onClick={() =>
                              selectImage(
                                `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                              )
                            }
                            title='Arrastar para Image 1 ou Image 2'
                          >
                            <img
                              draggable={false}
                              style={{width: '100%', height: '100%', objectFit: 'cover'}}
                              src={`https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`}
                              alt={`Exemplo ${item}`}
                            />
                            {selectedImages.includes(
                              `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                            ) && (
                              <>
                                <div
                                  className='position-absolute top-0 start-0 w-100 h-100'
                                  style={{backgroundColor: 'rgba(80, 205, 137, 0.15)'}}
                                ></div>
                                <div className='position-absolute top-0 end-0 m-2'>
                                  <i className='bi bi-check-circle-fill text-success fs-2'></i>
                                </div>
                              </>
                            )}
                            <div className='position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white text-center py-1'>
                              <small className='fw-bold'>Imagem {item}</small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Botão Salvar */}
              <div className='d-flex justify-content-end pt-4 border-top'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={8}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => changeBookingConfig()}
                  btnClass='fw-bolder'
                />
              </div>
            </div>
          </div>

          <ModalWrapper confirmAction={async () => await changeDayBookingConfig()}>
            <div className='d-flex flex-column gap-6' style={{maxWidth: 335}}>
              <div className='d-flex flex-row gap-2 align-items-end'>
                <span className='fw-bolder fs-6 mb-1'>{i18n.t(`booking.booking_day`)}</span>
                <Input
                  checkSwift
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  checked={daySelected?.able}
                  value={daySelected?.able}
                  change={(value: boolean) => {
                    if (daySelected) {
                      const day = Object.assign(daySelected)
                      day.able = value
                      setDaySelected(day)
                    }
                  }}
                />
              </div>
              <span className='fw-bolder fs-6 mb-1'>{i18n.t(`booking.booking_day_text`)}</span>
              <div className='d-flex flex-row flex-wrap'>
                {[
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
                  24,
                ].map((value) => (
                  <div
                    onClick={() => changeHour(value < 10 ? `0${value}:00` : `${value}:00`)}
                    className={
                      daySelected?.bookingHours.includes(
                        value < 10 ? `0${value}:00` : `${value}:00`
                      )
                        ? styles.dayItemSelected
                        : styles.dayItem
                    }
                  >
                    <p>{value < 10 ? `0${value}` : value}:00</p>
                  </div>
                ))}
              </div>
              <span className='fw-normal text-muted fs-7 mb-1 my-1'>
                {i18n.t(`booking.booking_day_subtext`)}
              </span>
            </div>
          </ModalWrapper>
        </>
      )}
    </>
  )
}

const BookingConfig: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`booking.config`), path: 'booking/config', isActive: true},
        ]}
      >
        {i18n.t(`booking.config`)}
      </PageTitle>
      <BookingConfigContent />
    </>
  )
}

export {BookingConfig}
